export default __webpack_public_path__ + "static/media/playup-logo-inverted.383319c5.svg";